import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { Contract } from '../../class/contract';

@Injectable()
export class ContractService extends WebService {

    public getContract (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('citation.profile_survey.checklist_profile_survey.list_doc_profile_survey,company,citation.candidate,created_by,retired_by,citation.document_profile_survey'));

        const options = new RequestOptions({search: params, headers: this.headers});


        return this.http.get( `${this.apiUrl}/contracts?${params}`, options);
    }

    public newContract(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/contracts`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateContract(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/contracts/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteContract(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/contracts/${id}`, { headers: this.headers } );
    }

    public infoContract(id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/contracts?id=${id}`,  { headers: this.headers } );
    }

    public getDocumentProfileSurvey(citation_id: number){
        return this.http.get( `${this.apiUrl}/contracts/getFolders?citation_id=${citation_id}`,  { headers: this.headers } );
    }
    
    public getCheckListProfileSurvey(profile_survey_id: number){
        return this.http.get( `${this.apiUrl}/contracts/getDocumentsProfileSurvey?profile_survey_id=${profile_survey_id}`,  { headers: this.headers } );

    }

    public getDocumentProfileSurveyUnionCheckList(citation_id: number, profile_survey_id: number,type: string){
        return this.http.get( `${this.apiUrl}/contracts/getDocumentsProfileSurveyUnionChecklist?citation_id=${citation_id}&profile_survey_id=${profile_survey_id}&type=${type}`,  { headers: this.headers } );
    }

    public getDocumentProfileSurveyUnionCheckListOneDoc(citation_id: number, profile_survey_id: number,list_doc_profile_survey_id: string){
        return this.http.get( `${this.apiUrl}/contracts/getDocumentsProfileSurveyUnionChecklist?citation_id=${citation_id}&profile_survey_id=${profile_survey_id}&list_doc_profile_survey_id=${list_doc_profile_survey_id}`,  { headers: this.headers } );
    }

    public getDocumentProfileSurveyUnionCheckListRad(radication_id: number,list_doc_profile_survey_id: number, citation_id?: number, profile_survey_id?: number){
        let params: URLSearchParams = new URLSearchParams();
        if (citation_id !== null) {
            params.append('citation_id', String(citation_id));
        }
        if (profile_survey_id !== null) {
            params.append('profile_survey_id', String(profile_survey_id));
        }
        if (radication_id !== null) {
            params.append('radication_id', String(radication_id));
        }
        if (list_doc_profile_survey_id !== null) {
            params.append('list_doc_profile_survey_id', String(list_doc_profile_survey_id));
        }
        return this.http.get( `${this.apiUrl}/contracts/getDocumentsProfileSurveyUnionChecklistRadication?${params}`,  { headers: this.headers } );
        //return this.http.get( `${this.apiUrl}/contracts/getDocumentsProfileSurveyUnionChecklistRadication?citation_id=${citation_id}&profile_survey_id=${profile_survey_id}&radication_id=${radication_id}`,  { headers: this.headers } );
    }

    public contractsObservations(candidate_id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/contracts/contracts-observations?candidate_id=${candidate_id}`,  { headers: this.headers } );
    }

    public newSynergoContract(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/contracts-synergo`, JSON.stringify(body) , { headers: this.headers } );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/contract/contract.service.ts